import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { useMergeRefs } from '@floating-ui/react';
import { asArray } from '@olivierpascal/helpers';
import { useStyles } from '../../hooks/useStyles';
import { createPolymorphicComponent, } from '../../helpers/react/polymorphicComponentTypes';
import { Base } from '../Base';
import { useVisualState } from '../VisualState';
import { StateLayer } from '../StateLayer';
import { FocusRing } from '../FocusRing';
import { navigationRailDestinationFocusRingStyles, navigationRailDestinationStateLayerStyles, navigationRailDestinationStyles, } from './NavigationRailDestination.styles';
import { navigationRailDestinationTheme } from './NavigationRailDestination.stylex';
import { Anchored } from '../Anchored';
export const NavigationRailDestination = createPolymorphicComponent(forwardRef(function NavigationRailDestination(props, forwardedRef) {
    const { as, styles, sx, innerStyles, visualState: visualStateProp, children, href, readOnly, icon, activeIcon, label, active, badge, ...other } = props;
    const visuallyDisabled = other.disabled || readOnly;
    const { visualState, setRef: setVisualStateRef } = useVisualState(visualStateProp, { disabled: visuallyDisabled });
    const visualStateRef = useRef(null);
    const handleRef = useMergeRefs([
        forwardedRef,
        setVisualStateRef,
        visualStateRef,
    ]);
    const { combineStyles, getStyles, globalStyles, settings } = useStyles({
        name: 'NavigationRailDestination',
        styles: [navigationRailDestinationStyles, styles],
        visualState,
    });
    const rootElement = as ?? (href ? (settings?.linkAs ?? 'a') : 'button');
    return (_jsxs(Base, { as: rootElement, href: href, role: 'button', tabIndex: visuallyDisabled ? -1 : 0, ...other, visualState: visualState, sx: [
            globalStyles,
            navigationRailDestinationTheme,
            combineStyles('host', active ? 'host$active' : 'host$inactive', !label && 'host$noLabel'),
            sx,
        ], ref: handleRef, children: [visuallyDisabled ? null : (_jsx(FocusRing, { styles: [
                    navigationRailDestinationFocusRingStyles,
                    ...asArray(innerStyles?.focusRing),
                ], for: visualStateRef, visualState: visualState })), _jsxs("div", { ...getStyles('iconContainer', !label && 'iconContainer$noLabel'), children: [active ? (_jsx("div", { ...getStyles('activeIndicator', !label && 'activeIndicator$noLabel') })) : null, _jsx(StateLayer, { styles: [
                            navigationRailDestinationStateLayerStyles,
                            ...asArray(innerStyles?.stateLayer),
                        ], for: visualStateRef, disabled: visuallyDisabled, visualState: visualState }), _jsx(Anchored, { content: badge, children: _jsx("div", { ...getStyles('icon', active ? `icon$active` : `icon$inactive`), children: active ? activeIcon : icon }) })] }), label ? (_jsx("div", { ...getStyles('labelText', active ? `labelText$active` : `labelText$inactive`), children: label })) : null, children] }));
}));
